export default __webpack_public_path__ + "static/media/pdf-light.c80b1847.svg";